/** @flow */
import tooltipsTranslations from "@modules/client/tooltips-translations";

export const clientMessages = {
  en: {
    PENDING_REVIEW_APPROVED: "Pending Review was successfully approved",
    PENDING_REVIEW_BLOCKED: "Pending Review was successfully blocked",
    PENDING_REVIEW_DEFFERED: "Pending Review was successfully deferred",
    CLIENT_CREATED: "Client was successfully created",
    CLIENT_UPDATED: "Client was successfully updated",
    SERVICE_UPDATED: "Service was successfully updated",
    EMPLOYEE_ASSIGNED: "The Employee was assigned to admin",
    ACCOUNT_CREATED: "The Account was successfully created",
    SLA_MEASURES_UPDATED: "SLA Measures Updated",
    SERVICE_SCOPE_WAS_SUCCESSFULLY_UPDATED: "Service Scope was successfully updated",
  },
};

export default {
  en: {
    ...tooltipsTranslations.en,
    CLIENT_ADMIN: "Client Admin",
    LINE_MANAGER: "Line Manager",
    FULL_ACCESS: "Full Access",
    ADMIN_TITLE: "Admin",
    // SLA
    SERVICE_LEVEL_AGREEMENTS: "Service Level Agreements",
    ADJUST_SLA_MEASURES: "Adjust SLA Measures",
    UPDATE_SLA_MEASURES: "Update SLA Measures",
    TARGET: "Target",
    TARGET_PERCENT: "Target %",
    CURRENT_PERCENT: "Current %",
    SLA_NAME: "SLA Name",
    SLA_DESCRIPTION: "SLA Description",
    SLA_TARGET: "SLA Target",
    STATUS: "Status",
    MEASURE: "Measure",
    PERIOD: "Period",
    ENABLED: "Enabled",
    DISABLED: "Disabled",
    QUARTERLY: "Quarterly",
    MONTHLY: "Monthly",
    // Side Nav
    CLIENT_DETAILS: "Client Details",
    EDIT_CLIENT: "Edit Client",
    SLA_MEASURES: "SLA Measures",
    SLA_PERFORMANCE: "SLA Performance",
    INTERACTIONS_BY_TYPE: "Interactions By Type",
    ASAP_CALLBACKS_SLA_PERCENTAGE: "Asap Callbacks SLA Percentage",
    SCHEDULED_CALLBACKS_SLA_PERCENTAGE: "Scheduled Callbacks SLA Percentage",
    NOTIFICATIONS_SLA_PERCENTAGE: "Notifications SLA Percentage",
    PERIOD_TOTAL: "Period Total",
    NO_DATA_PLEASE_APPLY_FILTERS: "No data, please apply filters.",
    SCOPE_AND_FILTERS: "Scope and Filters",
    REPORT_DETAILS: "Report Details",
    ADMIN_ACCOUNTS: "Admin Accounts",
    SERVICE_REVIEWS: "Service Reviews",
    CHANGE_HISTORY: "Change History",
    // Client List
    CLIENT_LIST: "Client List",
    ACTIVE_CLIENTS: "Active Clients",
    HEADCOUNT_COVERED: "Headcount Covered",
    ADD_NEW_CLIENT: "Add New Client",
    UPDATE_CLIENT: "Update Client",
    CLIENT_ID: "Client ID",
    CLIENT_NAME: "Client Name",
    NAME: "Name",
    CLIENT_ABSENCE_LINE: "Client Absence Line",
    OWNER: "Owner",
    HEAD_COUNT: "Headcount",
    INDUSTRY: "Industry",
    ACCOUNT_MANAGER: "Account Manager",
    REVIEW_CHANGES: "Review Changes",
    OVERDUE_CHANGES: "Overdue Changes",
    ADD_CLIENT: "Add Client",
    PROPOSED_BY: "Proposed By",
    SERVICE_ADMIN_TYPE: "Service Admin Type",
    CHANGE_ID: "Change ID",
    SUBMITTED_BY: "Submitted By",
    DATE_SUBMITTED: "Date Submitted",
    CHANGED_BY: "Changed By",
    DATE_CHANGED: "Date Changed",
    COMPLETED_CHANGES_NOTES: "Notes",
    DECISION_DUE_BY: "Decision Due By",
    DETAILS: "Details",
    // Employee Table
    EMPLOYEE_REF: "Employee Ref.",
    EMPLOYEE_INFORMATION: "Employee Information",
    ADDITIONAL_DETAILS: "Additional Details",
    PERIOD_TOTALS: "Period Totals",
    FIRST_NAME: "First Name",
    SURNAME: "Surname",
    EMAIL: "Email",
    SELECT: "Select",
    // Admin Account
    CREATE_EMPLOYEE_HEADER: "Create Admin Account: New Employee",
    CREATE_ADMIN_ACCOUNT_ACTION_TEXT: "Create Admin Account",
    CREATE_ADMIN_ACCOUNT_MODAL_HEADER: "Are you sure?",
    CHANGE_LOG: "Change Log",
    DISABLE_ADMIN: "Disable Admin",
    ENABLE_ADMIN: "Enable Admin",
    EXISTING_ADMIN: "Existing Admin",
    EXISTING_ADMIN_ACCOUNTS: "Existing Admin Accounts",
    CREATE_ADMIN_ACCOUNT_EXISTING_EMPLOYEE: "Create Admin Account: Existing Employee",
    CONFIRMATION_CREATE_ADMIN_ACCOUNT:
      "This will grant {firstName} {lastName} with the ability to administer their organisations data, service configuration and hierarchy.",
    CONFIRMATION_DISABLE_ADMIN_ACCOUNT: "Are you sure you want to disable {firstName} {lastName}?",
    CONFIRMATION_ENABLE_ADMIN_ACCOUNT:
      "This will grant {firstName} {lastName} with the ability to administer their organisations data, service configuration and hierarchy.",
    REFERENCE_NUMBER: "Reference Number",
    CREATE_NEW_ADMIN: "Create New Admin",
    CREATE_ADMIN: "Create Admin",
    EXISTING_EMPLOYEE: "Existing Employee",
    NEW_EMPLOYEE: "New Employee",
    CREATE_USING: "Create Using",
    SEARCH_SURNAME: "Search Employees by Surname",
    // Service Admin
    SERVICE_ADMIN: "Service Admin",
    APPROVAL_OUTCOME: "Approval Outcome",
    FROM: "From",
    TO: "To",
    //Service Scope
    APPLICABLE_SERVICES: "Applicable Services",
    MAIN_OPTIONS: "Main Options",
    ADDITIONAL_OPTIONS: "Additional Options",
    ABSENCE_MANAGEMENT_DEFAULT_CONFIGURATIONS: "Absence Management Default Configurations",
    SELF_SERVICE_ADMINISTRATION: "Self Service Administration",
    ADD_NEW_SERIVCE: "Add New Service",
    ADD_SERVICE: "Add Service",
    SELECT_SERVICE: "Select Service",
    CANT_ENABLE_IF_IN_PAST: "You can't enable a service with start date in the past",
    SERVICE: "Service",
    SERVICE_TYPE: "Service Type",
    CONTRACT_TYPE: "Contract Type",
    START_DATE: "Start Date",
    END_DATE: "End Date",
    SERVICE_STATUS: "Service Status",
    PILOT: "Pilot",
    FULL_HEADCOUNT: "Full Headcount",
    DEFAULT_CONFIGURATIONS: "Default Configurations",
    CALL_HANDLING_CONTROLS: "Call Handling Controls",
    ENHANCED_FEATURE_CONTROLS: "Enhanced Feature Controls",
    ABSENCE_LINE: "Absence Line",
    EMAIL_ADDRESS: "Email Address",
    EMAIL_APPEAR_AS: "Email Appear As",
    CALL_ANSWER_ADVISOR_TYPE: "Call Answer Advisor Type",
    NURSE_TRANSFER_TYPE: "Nurse Transfer Type",
    HOMEWORKING_BLOCK: "Homeworking Block",
    FCA_BLOCK: "FCA Block",
    CONSENT_BLOCK: "Consent Block",
    OVERFLOW_SUPPORT: "Overflow Support",
    AGGREGATED_BENCHMARKING: "Aggregated Benchmarking",
    EAP_SIGNPOSTING: "EAP Signposting",
    ABSENCE_MONITORING: "Absence Monitoring",
    REFERRAL_TRACKING: "Referral Tracking",
    ROLLOUT: "Rollout",
    COMPLETE_SUPPORT: "Complete Support",
    ESSENTIALS: "Essentials",
    FOCUSED: "Focused",
    // Self Service Request
    DEFERRED_BY: "Deferred By",
    DEFERRED_DATE: "Date Deferred",
    DEFERRED_REASON: "Reason for Deferral",
    DEFERRED_INFO: "Info for Deferral",
    CHANGE_SET_STATE: "Change Set State",
    DISCARDED: "Discarded",
    DRAFT: "Draft",
    COMMITTED: "Committed",
    PENDING_APPROVAL: "Pending Approval",
    DEFERRED: "Deferred",
    EFFECTIVE: "Effective",
    DECLINED: "Decline",
    API_DEVELOPER_ACCESS: "API Developer Access",
    DATA_FORECASTING: "Data Forecasting",
    MOBILE_APP_ACCESS: "Mobile App Access",

    //Self Service Requests
    SELF_SERVICE_APPROVALS: "Self Service Approvals",
    PENDING_CHANGES: "Pending Changes",
    PENDING: "Pending",
    CHANGE_REQUEST: "Change Request #{id}",
    BLOCK: "Block",
    DEFER: "Defer",
    APPROVE: "Approve",
    BLOCK_CHANGE_SET: "Block Change Set #{id}",
    BLOCK_CHANGES: "Block Changes",
    DEFER_CHANGE_SET: "Defer Change Set #{id}",
    DEFER_CHANGES: "Defer Changes",
    APPROVE_CHANGE_SET: "Approve Change Set #{id}",
    APPROVE_CHANGE_SET_PROMPT: "Are you sure you want to approve the pending change?",
    REVIEWED_BY: "Reviewed By",
    DATE_REVIEWED: "Date Reviewed",
    DECISION: "Decision",
    VIEW_CHANGES: "View Changes",
    REASON_FOR_DEFER: "Reason For Defer",
    ADDITIONAL_INFO: "Additional Info",
    ADDITIONAL_INFO_WITH_ID: "Additional Info - Absence #{id}",
    ORIGINAL_VALUE: "Original Value",
    PROPOSED_VALUE: "Proposed Value",
    APPROVE_CHANGES: "Approve Changes",
    REASON_FOR_BLOCK: "Reason For Block",
    SECTION: "Section",
    DETAILS_CHANGE_SET: "Details for Change #{id}",
    SUBMIT_AND_DEFER: "Submit & Defer",
    SUBMIT_AND_BLOCK: "Submit & Block",
    //Change Log
    HISTORIC_CHANGE_REQUEST_LOG: "Historic Change Request Log",

    // Filter
    APPLY_FILTER: "Apply Filters",

    // Client Details
    NAME_ADDRESS: "Name & Address",
    SECTOR_INDUSTRY: "Sector and Industry",
    ADDRESS_LINE: "Address Line",
    TOWN_CITY: "Town/City",
    POST_CODE: "Post Code",
    COUNTRY: "Country",
    REGION: "Region",
    CLIENT_OWNER: "Client Owner",
    SECTOR: "Sector",

    // Owerflow support types
    OVERFLOW_ONLY: "Overflow only",
    // Client managment statuses
    IN_TESTING: "In Testing",
    ACTIVE: "Active",
    INACTIVE: "Inactive",
  },
};
